import { render, staticRenderFns } from "./MenuRoutes.vue?vue&type=template&id=11387f22&scoped=true"
import script from "./MenuRoutes.vue?vue&type=script&lang=js"
export * from "./MenuRoutes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11387f22",
  null
  
)

export default component.exports